export default "__VITE_ASSET__Bcl9TLRu__"